import { FieldStyle } from '@feature/smart-reports-core/models/type';

export interface AggregationField {
	method: string;
	field: string;
	title?: string;
	conditionalFormattingConfiguration?: ConditionalFormatting[];
	order?: 'desc' | 'asc';
	style?: FieldStyle;
}

export interface AggregationData {
	[key: string]: any;
}

export interface ConditionalFormatting {
	fontStyle: string;
	fontSize: string;
	fontColor: string;
	methodName: ConditionalFormattingMethod;
	value: number | null;
}

export type ConditionalFormattingMethod =
	| 'less-than'
	| 'equal'
	| 'less-than-equal'
	| 'greater-than'
	| 'greater-than-equal';

export enum AggregationMethod {
	VALUE_COUNT = 'value_count',
	CARDINALITY = 'cardinality',
	SUM = 'sum',
	MAX = 'max',
	MIN = 'min',
	AVERAGE = 'avg',
	PERCENTAGE_N = 'n/n-1',
	PERCENTAGE_N_1 = 'n-1/n',
}

export const ScriptAggregations: string[] = [AggregationMethod.PERCENTAGE_N, AggregationMethod.PERCENTAGE_N_1];

export const NonFieldAggregationMethods: string[] = [
	AggregationMethod.VALUE_COUNT,
	AggregationMethod.PERCENTAGE_N,
	AggregationMethod.PERCENTAGE_N_1,
];

export interface EsAggregationObject {
	buckets: [];
	doc_count_error_upper_bound: number;
	sum_other_doc_count: number;
}
